<template>
  <m-pay-layout>
    <v-flex class="mx-2">

      <h2>About</h2>

      <div class="mt-4 mb-5 font-weight-bold grey--text ">
        Frontend version: {{ formatDateTime(commitDate) }}<br/>
        Backend version: {{ formatters.dateTime(metaData.remoteDate) }}
      </div>

      <h2>Documentation</h2>

      <div class="mt-4 mb-5 font-weight-bold grey--text ">

        <div>
          <a href="https://developers.klix.app" target="_blank">
            <v-icon>description</v-icon>
            Klix Developers
          </a>
        </div>

      </div>

      <h2>Resources</h2>

      <div class="mt-4 mb-5 font-weight-bold grey--text ">

        <div>
          <a href="/static/doc/klix_logo.svg" target="_blank">
            <v-icon>image</v-icon>
            klix_logo.svg
          </a>
        </div>

        <div>
          <a href="/static/doc/klix_logo.png" target="_blank">
            <v-icon>image</v-icon>
            klix_logo.png
          </a>
        </div>

      </div>

    </v-flex>

  </m-pay-layout>
</template>

<script>
import axios from 'axios';
import moment from 'moment-timezone';
import formatters from '../utils/formatters';
import queries from '../utils/queries';
import MPayMessage from './MPayMessage';

export default {
  name: 'MPayDocumentation',

  component: [MPayMessage],

  data: () => ({
    user: {},
    loading: false,
    version: '',
    commitDate: '',
    commitHash: '',
    commitMessage: '',
    metaData: {},
    formatters,
  }),

  methods: {
    fetchVersion() {
      this.loading = true;
      axios.get(queries.version())
        .then((response) => {
          this.version = response.data;
          this.loading = false;
        })
        .catch((e) => {
          this.showError(e);
          this.loading = false;
        });
      axios.get(queries.commitHash())
        .then((response) => {
          const data = response.data;
          const chunks = data.split('\n');
          this.commitDate = chunks[0];
          this.commitHash = chunks[1];
          this.commitMessage = chunks[2];
          this.loading = false;
        })
        .catch((e) => {
          this.showError(e);
          this.loading = false;
        });
      axios.get(queries.metaData())
        .then((response) => {
          this.metaData = response.data;
        })
        .catch((e) => {
          this.showError(e);
          this.loading = false;
        });
    },
    formatDateTime(dateTime) {
      const truncated = dateTime.substring(0, 16);
      return moment(truncated, 'YYYY-MM-DD HH:mm')
        .format('DD.MM.YYYY HH:mm');
    },
  },

  mounted() {
    this.fetchVersion();
  },

};
</script>



// WEBPACK FOOTER //
// src/components/MPayDocumentation.vue